import SkeletonTable from "@/components/SkeletonTable";
import api from "@/lib/axios";
import { useQuery } from "@tanstack/react-query";
import { columns } from "./partial/Columns";
import { DataTable } from "./partial/DataTable";

const getListTahapanCbt = async () => {
  const response = await api.get("/setting/keterangan-tahapan-cbt/index", {
    withCredentials: true,
  });
  return response.data?.data;
};

export default function SettingTahapanCbtPage() {
  const { data, isPending } = useQuery({
    queryKey: ["listTahapanCbt"],
    queryFn: getListTahapanCbt,
  });

  if (isPending) return <SkeletonTable />;

  return (
    <div>
      <DataTable data={data || []} columns={columns} />
    </div>
  );
}
